import { Data } from './Data';
import { Header } from './Header';

export const CutOffCell = { Data, Header };
